(function () {
  'use strict';
  const control = window.PPMMonsterTag;
  if (!control || control.ready) return;
  const pendingKey = 'ppm-monster-tag-pending-v1';
  const root = control.root.replace(/\/?$/, '/');
  let current = null;
  let clickedCard = null;
  let observer = null;
  let scheduled = false;
  let pending = null;

  function id(value) {
    return String(value == null ? '' : value).split('/').pop();
  }

  function tagLines(cart) {
    return cart.items.filter(item => id(item.product_id) === control.tagId || id(item.variant_id) === control.variantId);
  }

  function remember(value) {
    if (value) sessionStorage.setItem(pendingKey, JSON.stringify(value));
    else sessionStorage.removeItem(pendingKey);
    pending = value;
  }

  function engraving(front, back) {
    const f = front.trim();
    const b = back.trim();
    if (!f) throw new Error('Please enter Front Engraving.');
    if (front.length > 20 || f.length > 20) throw new Error('Front Engraving must be 20 characters or fewer.');
    if (back.length > 60 || b.length > 60) throw new Error('Back Engraving must be 60 characters or fewer.');
    return { 'Front Engraving': f, ...(b ? { 'Back Engraving': b } : {}) };
  }

  function monsterProperties(product, variant) {
    const props = { _monster_campaign: 'fbt_upsell' };
    const discount = product.discount;
    if (discount && discount.value != null && String(discount.value).trim() !== '') {
      if (!['percentage', 'fixed_amount', 'fixed_price'].includes(discount.type)) {
        throw new Error('This offer needs review before it can be added.');
      }
      const amount = Number(discount.value);
      if (!Number.isFinite(amount) || amount < 0 || (discount.type === 'percentage' && amount > 100)) {
        throw new Error('This offer needs review before it can be added.');
      }
      props._monster_discount_type = discount.type;
      props._monster_discount_value = String(discount.value);
    }
    const originalPrice = variant.compare_at_price || variant.compareAtPrice;
    if (originalPrice && Number(originalPrice) > 0) props._monster_original_price = String(originalPrice);
    return props;
  }

  async function readCart() {
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Could not check your cart. Please try again.');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('Could not check your cart. Please try again.');
    return cart;
  }

  function sameProperties(item, properties) {
    const actual = item.properties || {};
    return Object.entries(properties).every(([key, value]) => String(actual[key]) === String(value));
  }

  async function refresh() {
    if (typeof window.monster_refresh !== 'function') throw new Error('Please reopen your cart to review your tag.');
    await window.monster_refresh(true);
  }

  function text(message) {
    if (current) current.status.textContent = message;
  }

  function updateButtons() {
    if (!current) return;
    current.submit.disabled = control.busy || control.uncertain || current.completed;
    current.close.disabled = control.busy || control.uncertain;
    current.check.hidden = !control.uncertain;
    current.check.disabled = control.busy;
    current.front.readOnly = control.busy || control.uncertain;
    current.back.readOnly = control.busy || control.uncertain;
    current.form.setAttribute('aria-busy', String(control.busy));
    mount();
  }

  function card() {
    const wrapper = document.getElementById('monster-cart-wrapper');
    if (!wrapper) return null;
    function isTagCard(row) {
      return row &&
      Array.from(row.querySelectorAll('.mu-fbt-item-title a')).some(link => {
        try { return new URL(link.href).pathname.replace(/\/$/, '').endsWith('/products/14kgoldplatedbonetag'); }
        catch (error) { return false; }
      });
    }
    if (clickedCard && wrapper.contains(clickedCard) && isTagCard(clickedCard)) return clickedCard;
    return Array.from(wrapper.querySelectorAll('.mu-fbt-item')).find(isTagCard) || null;
  }

  function mount() {
    const wrapper = document.getElementById('monster-cart-wrapper');
    if (wrapper) wrapper.querySelectorAll('.mu-fbt-item-atc > span').forEach(label => {
      if (label.textContent !== 'ADD +') label.textContent = 'ADD +';
    });
    const host = card();
    const title = host && host.querySelector('.mu-fbt-item-title a');
    if (title && title.textContent !== 'SAFETY ID TAG') title.textContent = 'SAFETY ID TAG';
    const image = host && host.querySelector('.mu-fbt-item-image');
    if (image && control.featuredImage) {
      const background = 'url(' + JSON.stringify(control.featuredImage) + ')';
      if (image.style.backgroundImage !== background) image.style.backgroundImage = background;
    }
    const button = host && host.querySelector('.mu-fbt-item-atc');
    const open = !!(current && !current.completed);
    if (button) {
      button.setAttribute('aria-expanded', String(open));
      button.disabled = control.busy || control.uncertain;
    }
    if (!open) return;
    const drawer = wrapper && wrapper.firstElementChild;
    if (drawer && !drawer.contains(current.overlay)) {
      unlockPanel();
      drawer.appendChild(current.overlay);
      current.background = Array.from(drawer.children).filter(node => node !== current.overlay).map(node => {
        const inert = node.inert;
        node.inert = true;
        return { node, inert };
      });
      let scroller = drawer.querySelector('#mu-items-container');
      while (scroller && scroller !== drawer) {
        if (/(auto|scroll)/.test(getComputedStyle(scroller).overflowY)) {
          current.scrollLock = { node: scroller, overflow: scroller.style.overflow, top: scroller.scrollTop };
          scroller.style.overflow = 'hidden';
          break;
        }
        scroller = scroller.parentElement;
      }
      positionPanel();
    }
  }

  function positionPanel() {
    if (!current || current.completed || !current.overlay.isConnected) return;
    const viewport = window.visualViewport;
    if (!viewport) return;
    const bounds = current.overlay.parentElement.getBoundingClientRect();
    current.overlay.style.top = Math.max(0, viewport.offsetTop - bounds.top) + 'px';
    current.overlay.style.bottom = Math.max(0, bounds.bottom - viewport.offsetTop - viewport.height) + 'px';
  }

  function unlockPanel() {
    if (!current) return;
    (current.background || []).forEach(({ node, inert }) => { node.inert = inert; });
    current.background = [];
    if (current.scrollLock) {
      const { node, overflow, top } = current.scrollLock;
      node.style.overflow = overflow;
      node.scrollTop = top;
      current.scrollLock = null;
    }
  }

  function removePanel() {
    if (!current) return;
    unlockPanel();
    current.overlay.remove();
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', positionPanel);
      window.visualViewport.removeEventListener('scroll', positionPanel);
    }
  }

  function close() {
    if (!current || control.busy || control.uncertain) return;
    const host = card();
    removePanel();
    current = null;
    mount();
    const button = host && host.querySelector('.mu-fbt-item-atc');
    if (button) button.focus({ preventScroll: true });
  }

  async function complete(cart, properties) {
    const matching = tagLines(cart).filter(item => sameProperties(item, properties));
    if (matching.length !== 1 || matching[0].quantity !== 1 || tagLines(cart).length !== 1) {
      throw new Error('Please review the tag in your cart before continuing.');
    }
    remember(null);
    control.uncertain = false;
    if (current) {
      current.completed = true;
      current.front.value = '';
      current.back.value = '';
      removePanel();
    }
    await refresh();
  }

  async function reconcile() {
    if (control.busy || !pending) return;
    control.busy = true;
    updateButtons();
    try {
      const cart = await readCart();
      await complete(cart, pending.properties);
    } catch (error) {
      text('The add could not be confirmed. No second add will be sent. Review your cart or check again.');
    } finally {
      control.busy = false;
      updateButtons();
    }
  }

  async function performAdd(properties) {
    const before = await readCart();
    if (tagLines(before).length) {
      text('An engraved tag is already in your cart. Review it before adding another.');
      await refresh();
      return;
    }
    const payload = { items: [{ id: control.variantId, quantity: 1, properties }] };
    if (current.sellingPlan) payload.items[0].selling_plan = current.sellingPlan;
    remember({ properties });
    let response;
    try {
      response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
    } catch (error) {
      control.uncertain = true;
      try { await complete(await readCart(), properties); }
      catch (failure) { text('The add could not be confirmed. No second add will be sent. Check your cart.'); }
      return;
    }
    if (!response.ok) {
      if (response.status >= 400 && response.status < 500) {
        const after = await readCart().catch(() => null);
        if (after && tagLines(after).length === 0) {
          remember(null);
          text('Your tag could not be added. Please check availability and try again.');
          return;
        }
      }
      control.uncertain = true;
      try { await complete(await readCart(), properties); }
      catch (failure) { text('The add could not be confirmed. No second add will be sent. Check your cart.'); }
      return;
    }
    control.uncertain = true;
    try { await complete(await readCart(), properties); }
    catch (error) { text('Your tag may have been added. No second add will be sent. Check your cart.'); }
  }

  async function submit(event) {
    event.preventDefault();
    if (control.busy || control.uncertain || !current || current.completed) return;
    control.busy = true;
    updateButtons();
    try {
      const properties = { ...monsterProperties(current.product, current.variant), ...engraving(current.front.value, current.back.value) };
      current.front.removeAttribute('aria-invalid');
      text('Adding your personalized tag…');
      if (navigator.locks && navigator.locks.request) {
        await navigator.locks.request('ppm-monster-tag-add', { ifAvailable: true }, async lock => {
          if (!lock) { text('Your cart is being updated in another tab. Please try again.'); return; }
          await performAdd(properties);
        });
      } else await performAdd(properties);
    } catch (error) {
      if (pending) control.uncertain = true;
      text(error.message || 'Your tag could not be added. Please review your cart.');
      if (!current.front.value.trim()) {
        current.front.setAttribute('aria-invalid', 'true');
        current.front.focus();
      }
    } finally {
      control.busy = false;
      updateButtons();
    }
  }

  function revealFormTop() {
    const form = current && current.form;
    requestAnimationFrame(() => {
      if (!form || !form.isConnected || !current || current.form !== form) return;
      positionPanel();
      form.querySelector('.ppm-mu-tag-fields').scrollTop = 0;
      form.focus({ preventScroll: true });
    });
  }

  control.open = function (product, variant, sellingPlan) {
    if (id(variant && variant.id) !== control.variantId || !card()) return;
    observe();
    if (current && !current.completed) {
      mount();
      return;
    }
    const form = document.createElement('form');
    form.className = 'ppm-mu-tag-form';
    form.noValidate = true;
    form.tabIndex = -1;
    form.setAttribute('role', 'dialog');
    form.setAttribute('aria-modal', 'true');
    form.setAttribute('aria-label', 'Personalize your engraved ID tag');
    form.innerHTML = '<div class="ppm-mu-tag-close-row"><button type="button" class="ppm-mu-tag-close" aria-label="Close tag customization"><svg aria-hidden="true" viewBox="0 0 320 512"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"/></svg></button></div>' +
      '<div class="ppm-mu-tag-header"><img width="80" height="80" alt="SAFETY ID TAG"><div><b>SAFETY ID TAG</b><p class="ppm-mu-tag-price"></p></div></div>' +
      '<div class="ppm-mu-tag-fields"><label for="ppm-mu-tag-front">Front Engraving <span aria-hidden="true">*</span></label>' +
      '<input id="ppm-mu-tag-front" name="properties[Front Engraving]" type="text" required maxlength="20" autocomplete="off" autocorrect="off" aria-describedby="ppm-mu-tag-status">' +
      '<label for="ppm-mu-tag-back">Back Engraving</label>' +
      '<textarea id="ppm-mu-tag-back" name="properties[Back Engraving]" rows="2" maxlength="60" aria-describedby="ppm-mu-tag-status"></textarea>' +
      '<p id="ppm-mu-tag-status" class="ppm-mu-tag-status" role="status" aria-live="polite"></p>' +
      '<div class="ppm-mu-tag-actions"><button type="submit">CONFIRM</button><button type="button" data-check hidden>Check cart</button></div></div>';
    form.querySelector('.ppm-mu-tag-header img').src = control.featuredImage;
    const price = card().querySelector('.mu-fbt-item-price');
    if (price) form.querySelector('.ppm-mu-tag-price').innerHTML = price.innerHTML;
    const overlay = document.createElement('div');
    overlay.className = 'ppm-mu-tag-overlay';
    overlay.appendChild(form);
    current = {
      product, variant, sellingPlan, form, overlay, completed: false,
      front: form.querySelector('input'), back: form.querySelector('textarea'),
      status: form.querySelector('[role="status"]'), submit: form.querySelector('[type="submit"]'),
      check: form.querySelector('[data-check]'), close: form.querySelector('.ppm-mu-tag-close')
    };
    form.addEventListener('submit', submit);
    current.close.addEventListener('click', close);
    overlay.addEventListener('click', event => { if (event.target === overlay) close(); });
    overlay.addEventListener('touchmove', event => { if (event.target === overlay) event.preventDefault(); }, { passive: false });
    form.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const fields = Array.from(form.querySelectorAll('button, input, textarea')).filter(node => !node.disabled && !node.hidden);
      const first = fields[0];
      const last = fields[fields.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === form)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', positionPanel);
      window.visualViewport.addEventListener('scroll', positionPanel);
    }
    current.check.addEventListener('click', reconcile);
    mount();
    updateButtons();
    revealFormTop();
  };

  function observe() {
    const wrapper = document.getElementById('monster-cart-wrapper');
    if (!wrapper) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; mount(); });
    });
    observer.observe(wrapper, { childList: true, subtree: true });
  }

  function initialize() {
    document.addEventListener('click', event => {
      const button = event.target.closest && event.target.closest('#monster-cart-wrapper .mu-fbt-item-atc');
      if (button) clickedCard = button.closest('.mu-fbt-item');
    }, true);
    document.addEventListener('cart:updated', () => { observe(); mount(); });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && current && current.form.contains(document.activeElement)) {
        if (!control.busy && !control.uncertain) close();
        event.stopPropagation();
      }
    }, true);
    observe();
    mount();
  }

  try {
    pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
    if (pending) control.uncertain = true;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    control.ready = true;
  } catch (error) {
    control.ready = false;
  }
})();

